import { adminService } from '@/api/services';

import type { UnwrapData } from '../../types';

import type { ILMSAccountsDataResponse, IQuizzesDataResponse } from './types';

export const lmsDataService = adminService.injectEndpoints({
  endpoints: (builder) => ({
    /**
     * Получить список LMS аккаунтов
     */
    getLMSAccountsData: builder.query<UnwrapData<ILMSAccountsDataResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/lms/accounts',
      }),
      transformResponse: (response: ILMSAccountsDataResponse): UnwrapData<ILMSAccountsDataResponse> => response.data,
    }),
    /**
     * Получить список всех квизов
     */
    getQuizzesData: builder.query<UnwrapData<IQuizzesDataResponse>, void>({
      query: () => ({
        method: 'GET',
        url: '/lms/quizzes',
      }),
      transformResponse: (response: IQuizzesDataResponse): UnwrapData<IQuizzesDataResponse> => response.data,
    }),
  }),
});

export const { useGetLMSAccountsDataQuery, useGetQuizzesDataQuery } = lmsDataService;
